import { Route, Routes, Navigate } from "react-router-dom";
import { Suspense } from "react";
import { AuthData } from "../../auth/AuthWrapper";
import { isRouteAllowed, isSuperAdmin, isActiveUser } from "../../utils/authz";
import PendingApproval from "../../pages/PendingApproval";
import { nav } from "./navigation";
import NavBar from "../NavBar";
import LoginPage from "../../pages/LoginPage";
import { CircularProgress, Box } from "@mui/material";

// Loading компонент
const LoadingSpinner = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <CircularProgress />
  </Box>
);

export const RenderRoutes = () => {
  const { user, userProfile, isAuthReady } = AuthData();

  const canAccess = (path) => {
    if (!user?.isAuthenticated) return false;
    // Супер-админ бол үргэлж зөвшөөрнө (fallback: auth.currentUser.email)
    if (isSuperAdmin(userProfile)) return true;
    // Профайл ачаалаагүй үед дор хаяж Home-ыг нээх
    if (!userProfile) return path === "/home";
    // ACTIVE биш бол Pending рүү
    if (!isActiveUser(userProfile)) return false;
    if (path === "/home") return true;
    return isRouteAllowed(userProfile, path);
  };

  if (!isAuthReady) {
    return <LoadingSpinner />;
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route
          path="/"
          element={
            user.isAuthenticated ? (
              <Navigate to="/home" replace />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route path="/pending" element={<PendingApproval />} />
        {nav.map((r, i) => (
          <Route
            key={i}
            path={r.path}
            element={
              canAccess(r.path) ? (
                r.element
              ) : user.isAuthenticated ? (
                // Нэвтэрсэн боловч зөвшөөрөлгүй бол pending рүү
                <Navigate to="/pending" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        ))}
        <Route
          path="*"
          element={
            <Navigate to={user.isAuthenticated ? "/home" : "/"} replace />
          }
        />
      </Routes>
    </Suspense>
  );
};

export const RenderMenu = () => {
  return <NavBar />;
};
